import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import recommendationsCountModule from 'containers/App/data/endpoints/roomRecommendationsCountByDay';
import RecommendationsCalendar from './RecommendationsCalendar';

const RecommendationsCalendarWrapper = ({ filters, propertyId }) => {
    const recommendationsCountState = useSelector(recommendationsCountModule.selectors.selectState);
    const dispatch = useDispatch();
    const fetchData = () => {
        dispatch(recommendationsCountModule.actions.resetState());
        dispatch(recommendationsCountModule.actions.fetch(propertyId, filters.startDate, filters.endDate));
    };

    useEffect(() => {
        fetchData();
        return () => {
            dispatch(recommendationsCountModule.actions.resetState());
        };
    }, [propertyId, filters]);

    return (
        <>
            {(!recommendationsCountState.fetched || recommendationsCountState.fetching) && (
                <RecommendationsCalendar filters={filters} data={[]} />
            )}
            {recommendationsCountState.fetched && (
                <RecommendationsCalendar filters={filters} data={recommendationsCountState.data} />
            )}
        </>
    );
};

export default RecommendationsCalendarWrapper;
